var app = angular.module('directives.creditBanner');
var template = require('../templates/index.html');

app.directive('creditBanner', ['$window', '$timeout',
    function($window, $timeout) {
        return {
            restrict: 'E',
            template: template,
            scope: {
                mini: '@',
                categoryId: '@'
            },
            controller: 'creditBanner',
            link: function(scope, element, attrs) {
                if (scope.mini !== 'true') return;

                var $banner = element.find('.service-banner');
                
                function checkScreenSize() {
                    var windowWidth = $window.innerWidth;
                    
                    if (windowWidth < 992) {
                        $banner.removeClass('mini');
                    } else {
                        $banner.addClass('mini');
                    }
                }
                
                $timeout(checkScreenSize, 100);
                
                angular.element($window).on('resize', function() {
                    scope.$apply(function() {
                        checkScreenSize();
                    });
                });
                
                scope.$on('$destroy', function() {
                    angular.element($window).off('resize');
                });
            }
        }
    }
]);

app.controller('creditBanner', function ($scope) {
    // Mapping category ID to location name for analytics
    var categoryLocationMap = {
        '33': 'mobile',
        33: 'mobile',
        '37': 'payments',
        37: 'payments',
        '34': 'internet',
        34: 'internet',
        '42': 'charity',
        42: 'charity',
        '48': 'education',
        48: 'education',
        '67': 'financial',
        67: 'financial',
        'all': 'popular',
        'other': 'other',
        'favorites': 'favorites'
    };
    
    $scope.categoryLocation = categoryLocationMap[$scope.categoryId] || $scope.categoryId;
});




/*****************
 ** WEBPACK FOOTER
 ** ./app/directives/creditBanner/directives/creditBanner.js
 ** module id = 156
 ** module chunks = 1
 **/